var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAutomationAvatarDefault = function SvgIconAutomationAvatarDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_automation_avatar_default_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m40.934 17.388.492-1.132a8.72 8.72 0 0 1 4.44-4.5l1.518-.678a1.06 1.06 0 0 0 0-1.926l-1.434-.638a8.74 8.74 0 0 1-4.502-4.652l-.506-1.222a1.012 1.012 0 0 0-1.884 0l-.506 1.22a8.74 8.74 0 0 1-4.5 4.654l-1.436.64a1.06 1.06 0 0 0 0 1.924l1.52.676a8.72 8.72 0 0 1 4.438 4.502l.492 1.132c.36.828 1.506.828 1.868 0M11.6 32h4.308l1.2-3h5.784l1.2 3H28.4L22 16h-4zM20 21.77 21.292 25h-2.584zM30 32V16h4v16zM6 6a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V22h-4v16H8V10h20V6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_automation_avatar_default_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgIconAutomationAvatarDefault;